import { BooleanToggleActions } from './BooleanToggleActions';

export const EvaluateCompany = ({
    company,
    isLoading = () => false,
    onApprove,
    onSelectForDisapprove
}) => {

    const loading = isLoading(company.id);

    return (
        <BooleanToggleActions
            value={company.estaAprobado}
            loading={loading}
            onTrue={() => onApprove(company.id)}
            onFalse={() => onSelectForDisapprove(company.id)}
            falseProps={{
                "data-bs-toggle": "modal",
                "data-bs-target": "#desaprobarUsuario"
            }}
        />
    );
};